export const SidebarStyle = {
  PaperStyle: {
    position: "relative",
    borderRadius: 0,
    boxShadow: "none",
    bgcolor: "#ffffff",
    minHeight: "100vh",
    maxHeight: "100vh",
    overflow: "hidden",
    width: "100%",
  },
  MotionPaperStyle: {
    width: "400px",
    maxWidth: "min(400px, 100vw)",
    height: "100dvh",
    maxHeight: "100dvh",
    zIndex: 10,
    borderRadius: "0px 15px 15px 0px",
    transition: "all 2s",
    // Column so the drawer body fills the full height: nav scrolls, Logout stays at the bottom.
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    boxSizing: "border-box",
    bgcolor: "#ffffff",
  },
  SidebarDrawerBody: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  SidebarDrawerHeader: {
    flexShrink: 0,
    width: '100%',
    pl: { xs: 7, sm: 7 },
    pr: { xs: 2, sm: 2.5 },
    pt: { xs: 2.5, sm: 3 },
    pb: { xs: 2, sm: 2.5 },
  },
  SidebarBrandRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: { xs: '6px', sm: '8px' },
    cursor: 'pointer',
    bgcolor: 'white',
  },
  SidebarBrandLogo: {
    width: { xs: 34, sm: 38 },
    height: 'auto',
    display: 'block',
    objectFit: 'contain',
    flexShrink: 0,
  },
  SidebarBrandText: {
    fontFamily: 'Poppins, Inter, sans-serif',
    fontWeight: 500,
    fontSize: { xs: '8px', sm: '9px', md: '10px' },
    lineHeight: 1.2,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    color: '#111034',
    m: 0,
    mt: { xs: '15px', sm: '16px', md: '17px' },
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  SidebarDrawerNav: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    width: '100%',
    pl: { xs: 5, sm: 6 },
    pr: { xs: 2, sm: 2.5 },
  },
  // Pinned under the scrolling nav; same side padding as SidebarDrawerNav so
  // Logout lines up with the menu items above it.
  SidebarLogoutFooterStyle: {
    flexShrink: 0,
    width: "100%",
    pl: { xs: 5, sm: 6 },
    pr: { xs: 2, sm: 2.5 },
    pt: 1.5,
    pb: "calc(16px + env(safe-area-inset-bottom, 0px))",
    borderTop: "1px solid #EDEFF2",
    bgcolor: "#ffffff",
    boxSizing: "border-box",
  },
  // Shared look for every sidebar entry (menu links and Logout).
  SidebarItemStyle: {
    ":hover": {
      background: "#f8f9fa",
      border: "1px solid #2261a2",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 8px rgba(34, 97, 162, 0.15)",
    },
    border: "1px solid transparent",
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: { xl: "14px", lg: "14px", md: "14px", sm: "13px", xs: "13px" },
    width: "95%",
    maxWidth: "230px",
    minHeight: "38px",
    height: "auto",
    py: 0.75,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": { color: "#2261a2" },
    display: "flex",
    justifyContent: "flex-start",
    gap: "12px",
    alignContent: "center",
    alignItems: "center",
    paddingLeft: "16px",
    marginBottom: "4px",
  },
  SidebarLogoutButton: {
    color: "#2c3e50",
    background: "transparent",
    textAlign: "left",
    "& .MuiSvgIcon-root": { fontSize: 20 },
    "&:focus-visible": { outline: "2px solid #2261a2", outlineOffset: "2px" },
  },
  CloseMenuButton: {
    position: "absolute",
    width: "50px",
    height: "50px",
    transform: "rotate(90deg)",
    top: 10,
    right: 0,
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "transparent",
    },
  },
  BoxStyle: {
    width: "100%",
    marginY: "2px",
    height: { xl: "45x", lg: "45px", md: "45px", sm: "45px", xs: "37px" },
    bgcolor: "white",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "rgba(156, 206, 255, 0.31)",
    },
  },

  TextStyle: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: { xl: "15px", lg: "15px", md: "15px", sm: "14px", xs: "14px" },
    width: "100%",
    color: "#1D3163",
    lineHeight: "25px",
    cursor: "pointer",
    "&:hover": {
      color: "#C83F91",
    },
  },
  SidebarAccordionStyle: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: { xl: "14px", lg: "14px", md: "14px", sm: "14px", xs: "14px" },
    "&:hover": {
      color: "#445FD2",
    },
    width: "100%",
    color: "#1D3163",
    lineHeight: "25px",
    cursor: "pointer",
    mt: 2,
  },

  ButtonStyle: {
    width: "100%",
    maxWidth: "270px",
    minHeight: "40px",
    height: "auto",
    py: 0.75,
    background: "transparent",
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      bgcolor: "#443FD8",
    },
  },

  LogoutText: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "15px",
    color: "#000",
    textAlign: "left",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },

  OutLetParentStyle: {
    width: "100%",
    maxWidth: "100%",
    px: 0,
    py: 0,
    mt: 0,
    mx: 0,
    bgcolor: "#ffffff",
    borderRadius: 0,
    minHeight: "calc(100vh - 56px)",
    maxHeight: "calc(100vh - 56px)",
    overflowY: "auto",
    overflowX: "hidden",
    position: "relative",
  },

  OutLetBoxStyle: {
    width: "100%",
    maxWidth: "100%",
    mx: 0,
    px: 0,
    minHeight: "100%",
    bgcolor: "transparent",
    position: "relative",
    overflowX: "hidden",
  },

  Barterstyle: {
    position: "fixed",
    top: "55%",
    left: "55%",
    transform: "translate(67%, -52%)",
    width: "350px",
    height: "550px",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "20px",
  },

  styleCall: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xl: 400, lg: 400, md: 400, sm: 320, xs: 320 },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "20px",
  },
};